import styles from "./ToggleSwitch.module.css";

const ToggleSwitch = ({ checked, onChange, disabled = false }) => {
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={styles.slider}></span>
    </label>
  );
};

export default ToggleSwitch;
